// @ts-check
import angular from "angular";
import certificationBadge from "./certification-badge.html";
import './certification-badge.css';

export default angular
  .module("certificationBadgeComponent", [])
  .component("certificationBadge", {
    template: certificationBadge,
    controller: function() {},
    bindings: {
      certification: "=",
    },
    controllerAs: "$ctrl",
  });
